/* Il ritorno alla pagina di partenza (c37).
   La pagina di consenso di Claude arriva da un link di Supabase con un codice che scade: se la persona
   deve prima entrare o dare il codice di sicurezza, dopo deve tornare lì. Solo percorsi interni. */

/** Un percorso del gestionale, o null: deve iniziare con «/» e non con «//» né «/\». */
export const percorsoInterno = (p) => {
  // Niente caratteri di controllo (tab, a capo…): `new URL` li toglie e «/\t/sito.it» diventerebbe «//sito.it».
  if (typeof p !== "string" || !/^\/(?![/\\])/.test(p) || [...p].some((c) => c.charCodeAt(0) < 32 || c.charCodeAt(0) === 127)) return null;
  try {
    return new URL(p, window.location.origin).origin === window.location.origin ? p : null; // tab e a capo non fanno uscire dal sito
  } catch {
    return null;
  }
};

/** Il `next` di un indirizzo, se è un percorso interno. */
export const ritornoDa = (search) => percorsoInterno(new URLSearchParams(search).get("next"));

/** Dove serve tornare: per ora la sola pagina di consenso. Le altre pagine ripartono da «/», come sempre. */
export const serveRitorno = (pathname) => pathname.startsWith("/oauth/");

/** `verso` con il ritorno alla pagina in cui si è, se serve. */
export const conRitorno = (verso, dove) =>
  serveRitorno(dove.pathname) ? `${verso}?next=${encodeURIComponent(dove.pathname + dove.search)}` : verso;
